import {Component} from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin-overlay.component.html',
  styleUrls: ['./admin-overlay.component.scss']
})
export class AdminOverlayComponent {}
